import React, { useState } from "react";
import { Row, Col, Card, Form } from "react-bootstrap";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from "primereact/inputtextarea";
import axios from "axios";
import config from "../config";
import { useAuth } from "../context/AuthContext";

const AddLeadForm = ({ onClose, onLeadAdded }) => {
    const { accessToken, userId } = useAuth();

    // ✅ Form states
    const [leadName, setLeadName] = useState("");
    const [leadType, setLeadType] = useState(null);
    const [customLeadType, setCustomLeadType] = useState("");
    const [phoneNo, setPhoneNo] = useState("");
    const [requirement, setRequirement] = useState("");
    const [email, setEmail] = useState("");
    const [status, setStatus] = useState("Draft");
    const [loading, setLoading] = useState(false);
    const [dialogMessage, setDialogMessage] = useState('');
    const [showMessageDialog, setShowMessageDialog] = useState(false);

    const showMessage = (message) => {
        setDialogMessage(message);
        setShowMessageDialog(true);
    };

    // ✅ Dropdown options
    const leadTypes = [
        { label: "Weddings", value: "Weddings" },
        { label: "Social Media", value: "Social Media" },
        { label: "Website", value: "Website" },
        { label: "Motion Graphics", value: "Motion Graphics" },
        { label: "Static", value: "Static" },
        { label: "Others", value: "Others" }, // ✅ fixed spelling
    ];

    // ✅ Submit form data
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validation
        if (!leadName || !leadType || !phoneNo) {
            showMessage("Please fill in all required fields.");
            return;
        }

        // ✅ Use custom lead type if "Others" selected
        const finalLeadType = leadType === "Others" ? customLeadType : leadType;

        if (leadType === "Others" && !customLeadType.trim()) {
            showMessage("Please specify the custom lead type.");
            return;
        }

        setLoading(true);
        try {
            const payload = {
                user_id: userId,
                lead_name: leadName,
                lead_type: finalLeadType, // ✅ updated value
                phone_no: phoneNo,
                requirement,
                email,
                status,
            };

            await axios.post(`${config.apiBASEURL}/Client_LeadRoutes/addclientlead`, payload, {
                headers: { Authorization: `Bearer ${accessToken}` },
            });

            onLeadAdded(); // refresh parent list
            onClose(); // close sidebar
        } catch (error) {
            console.error("Error adding client lead:", error);
            showMessage("Failed to add client lead.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
        <Form onSubmit={handleSubmit}>
            <Row className="mb-3">
                 <h6 className="text-black mb-4">Add Referral</h6>
                <Col lg="12" className="mb-0">
                    <Card className="shadow-0 p-0 border-0">
                        <Card.Body className="p-0">
                            {/* Lead Name */}
                            <Form.Group className="mb-3">
                                <Form.Label>
                                    Lead Name <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter lead name"
                                    value={leadName}
                                    onChange={(e) => setLeadName(e.target.value)}
                                    required
                                />
                            </Form.Group>

                            {/* Lead Type */}
                            <Form.Group className="mb-3">
                                <Form.Label>
                                    Lead Type <span className="text-danger">*</span>
                                </Form.Label>
                                <Dropdown
                                    value={leadType}
                                    options={leadTypes}
                                    onChange={(e) => setLeadType(e.value)}
                                    placeholder="Select lead type"
                                    className="w-100"
                                />
                            </Form.Group>

                            {/* Custom Lead Type (if Others selected) */}
                            {leadType === "Others" && (
                                <Form.Group className="mb-3">
                                    <Form.Label>Specify Lead Type</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter custom lead type"
                                        value={customLeadType}
                                        onChange={(e) => setCustomLeadType(e.target.value)}
                                        required
                                    />
                                </Form.Group>
                            )}

                            {/* Phone Number */}
                            <Form.Group className="mb-3">
                                <Form.Label>
                                    Phone Number <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter phone number"
                                    value={phoneNo}
                                    onChange={(e) => setPhoneNo(e.target.value)}
                                    required
                                />
                            </Form.Group>

                            {/* Email */}
                            <Form.Group className="mb-3">
                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                    type="email"
                                    placeholder="Enter email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </Form.Group>

                            {/* Requirement */}
                            <Form.Group className="mb-3">
                                <Form.Label>Requirement</Form.Label>
                                <InputTextarea
                                    rows={3}
                                    placeholder="Describe the requirement..."
                                    value={requirement}
                                    onChange={(e) => setRequirement(e.target.value)}
                                    className="w-100 h-auto"
                                />
                            </Form.Group>
                        </Card.Body>
                    </Card>
                </Col>

                {/* Submit Button */}
                <Col lg="12" className="d-flex justify-content-end mt-0">
                    <Button
                        type="submit"
                        label={loading ? "Saving..." : "Save"}
                        icon="pi pi-save"
                        severity="success"
                        className="py-2"
                        disabled={loading}
                    />
                </Col>
            </Row>
        </Form>
        <Dialog
            header="Add Referral"
            visible={showMessageDialog}
            onHide={() => setShowMessageDialog(false)}
            modal
            style={{ width: '420px' }}
            footer={
                <Button
                    label="OK"
                    icon="pi pi-check"
                    onClick={() => setShowMessageDialog(false)}
                />
            }
        >
            <p className="mb-0">{dialogMessage}</p>
        </Dialog>
        </>
    );
};

export default AddLeadForm;
